import React, { memo, useMemo, useCallback } from 'react'
import Masonry from 'react-masonry-css'
import TaskCard from './TaskCard'

const MyTaskCardView = ({
  tasks,
  deleteTask,
  setIsDelegateOpen,
  setTask,
  setProcessReferenceNumber,
  teamDetails,
  breakpoints,
  visibleData,
  onNavigate,
}) => {
  const visibleDataMap = useMemo(
    () => new Map((visibleData || []).map((item) => [item.process_id, item.extracted_values])),
    [visibleData],
  )

  const renderTaskCard = useCallback(
    (task) => (
      <div className="mb-3" key={task.process_id}>
        <TaskCard
          task={task}
          deleteTask={deleteTask}
          setIsDelegateOpen={setIsDelegateOpen}
          setTask={setTask}
          setProcessReferenceNumber={setProcessReferenceNumber}
          teamDetails={teamDetails}
          visibleDataMap={visibleDataMap}
          onNavigate={onNavigate}
        />
      </div>
    ),
    [
      deleteTask,
      setIsDelegateOpen,
      setTask,
      setProcessReferenceNumber,
      teamDetails,
      visibleDataMap,
      onNavigate,
    ],
  )

  return (
    <Masonry
      breakpointCols={breakpoints}
      className="my-masonry-grid task-card-container dflex-sec"
      columnClassName="my-masonry-grid_column taskcardwidth"
    >
      {tasks?.map(renderTaskCard)}
    </Masonry>
  )
}

export default memo(MyTaskCardView)
